import { Injectable } from '@angular/core';
//import { HttpClient } from '@angular/common/http';

import { Device } from '@ionic-native/device/ngx';
import { Platform } from '@ionic/angular';
import { GlobalService } from '../global/global.service';

// add global variables here
import * as Constants from '../constants/constants';

declare var window;

/*
  PETER MATUCHNIAK 2018-03-05 / 2019-02-25
  Determine the runtime environment (such as BROWSER vs NATIVE, etc.)
*/

@Injectable({
  providedIn: 'root'
})
export class RuntimeService {

  consoleLog:boolean = false;

  _isBrowser:boolean = false;
  _isApp:boolean = false;
  _isCordova:boolean = false;
  _isNative:boolean = false;
  _isMobileWeb:boolean = false;
  _isDesktop:boolean = false;
  _isEmulator:boolean = false;
  _useCors:boolean = false;
  _useHttpProxy:boolean = true;
  _useEncodeUri:boolean = true; // true;

  // device specific
  _DeviceTypeCode:string = "unknown";
  _DeviceBrandCode:string = "unknown";
  _DevicePlatformCode:string = "unknown";
  _DeviceProductCode:string = "unknown";
  _DeviceOsVersionCode:string = "unknown";
  _AmbitMobileAppRunContext:string = "unknown";
  _NativeDeviceUuid:string = "unknown";
  _DeviceCarrierCode:string = "unknown";

  // browser info
  _browserInfo:any = {};

  constructor(private device: Device
    , private platform: Platform
    , public globalProvider: GlobalService
    )
  { 
    console.log('runtime.ctor - LifeCycle');
    this.consoleLog = this.globalProvider.consoleLog_runtime;
    //if (this.consoleLog) console.log('RuntimeProvider.ctor - LifeCycle');

    this.platform.ready().then(() => {
      if (this.consoleLog) console.log("runtime.ctor - platform ready!");
      this.InitializeProvider("ctor");
    });
  }

  public InitializeProvider(context:string)
  {
    this.DetermineExecutionEnv();
    this.DetermineDeviceInfo();
  }

  DetermineExecutionEnv():string
  {
    if (this.consoleLog) console.log("runtime.DetermineExecutionEnv", this.device);
    if (this.consoleLog) console.log("runtime.DetermineExecutionEnv device.platform:", this.device.platform);
    if (this.consoleLog) console.log("runtime.DetermineExecutionEnv platform:", this.platform);
    if (this.consoleLog) console.log("runtime.DetermineExecutionEnv document.URL:" + document.URL);

    let usePlatformService:boolean = true;

    if (usePlatformService === true)
    {
        this._isMobileWeb = this.platform.is('mobileweb');
        this._isDesktop = this.platform.is('desktop');
        this._isCordova = this.platform.is('cordova');
        this._isNative = this.platform.is('hybrid');
        this.globalProvider.isNative = this._isNative;

        if ((this._isCordova) || (this._isNative))
        {
          // NATIVE APP
          this._isBrowser = false;
          this._isApp = true;
          this._useHttpProxy = true;
          this._useCors = false;
        }
        else
        {
          // BROWSER APP
          this._isBrowser = true;
          this._isApp = false;    
          this._useHttpProxy = false;
          this._useCors = false; // may be overridden below

          if (document.URL.startsWith('http://localhost'))
          {
            if (this.consoleLog) console.log("ApiFunctionUrl: Environment LOCALHOST and NOT on device - use CORS");
            this._useCors = true;
          }
        }
    }
    else
    {
      // OLD WAY -- works in debug native builds for Android but NOT on production build - d'oh

      // https://stackoverflow.com/questions/38470325/how-to-detect-if-i-am-in-browser-local-development-in-ionic-2
      // if(this.platform.is('core') || this.platform.is('mobileweb')) 
      if (this.platform.is('desktop') )
      {
        this._isApp = false;
        this._isBrowser = true;
        this._isDesktop = true;
        if (this.consoleLog) console.log("runtime.DetermineExecutionEnv: DESKTOP");
      }
      else if ( this.platform.is('mobileweb') )
      {
        this._isApp = false;
        this._isBrowser = true;
        this._isMobileWeb = true;
        if (this.consoleLog) console.log("runtime.DetermineExecutionEnv: MOBILEWEB");
      }
      else 
      {
        this._isApp = true;
        this._isBrowser = false;
        if (this.consoleLog) console.log("runtime.DetermineExecutionEnv: APP (neither desktop nor mobileweb)");
      }

      // http://damien.antipa.at/blog/2014/02/08/3-ways-to-detect-that-your-application-is-running-in-cordova-slash-phonegap/
      try
      {
        this._isCordova = !!window.cordova;
        if (this.consoleLog) console.log("runtime.DetermineExecutionEnv: CORDOVA");

        // also
        //if (this.platform.is('cordova'))
        //{
        //  this._isCordova = true;
        //}
      }
      catch (error)
      {
        console.warn("runtime.DetermineExecutionEnv: testing for cordova error (not serious)", error);
      }

      try
      {
        this._isNative = this.device.platform == null ? false : true;
        this.globalProvider.isNative = this._isNative;
        if (this.consoleLog) console.log("runtime.DetermineExecutionEnv: NATIVE");
      }
      catch (error)
      {
        console.warn("testing for device error (not serious)", error);
      }

      // try to determine if this ts the iPhone Emulator (which may need to use CORS)
      if ( (this._isCordova ) && (this._isApp ) && (!this._isNative ) )  // true true false
      {
        if (this.consoleLog) console.log("api.ApiFunctionUrl - assuming Emulator (Cordova App but not native)");
        this._isEmulator = true;
      }

      // try to determine if we are natively on the device and should use Http Proxy instead
      if ( (this._isCordova ) && (this._isApp ) && (this._isNative ) ) // true true true
      {
        if (this.consoleLog) console.log("api.ApiFunctionUrl - assuming running on device as native");
        this._useHttpProxy = true;
        this._useCors = false;
      }
      else
      {
        this._useHttpProxy = false;
        if (document.URL.startsWith('http://localhost'))
        {
          if (this.consoleLog) console.log("ApiFunctionUrl: Environment LOCALHOST and NOT on device - use CORS");
          this._useCors = true;
        }
      }

      // NOTE: when debugging through a device it looks like we need to use the CORS API
      //   
      //if (this.IsNative())
      //{
      //  console.log("ApiFunctionUrl: Environment is NATIVE - do NOT use CORS");
      //  this._useCors = false;
      //}
      //else 
      /*
      if (document.URL.startsWith('http://localhost'))
      {
        if (this._useHttpProxy === true)
        {
          this._useCors = false;
        }
        else
        {
          console.log("ApiFunctionUrl: Environment is LOCALHOST and  - use CORS");
          this._useCors = true;
        }
      }
      else if (this.IsEmulator())
      {
        console.log("ApiFunctionUrl: Environment is EMULATOR - use CORS");
        this._useCors = true;
      }
      else
      {
        console.log("ApiFunctionUrl: Environment is NOT Localhost/Emulator - default to NOT use CORS");
        this._useCors = false;
      }
      */
    }

    if (this.consoleLog) console.log("runtime.DetermineExecutionEnv - runtime: " + this.GetRuntimeName());
    return this.GetRuntimeName();
  }

  // GETTERS FOR ALL THE CALCULATED VALUES FOR RUNTIME
  IsBrowser()    {  return this._isBrowser;    }
  IsApp()        {  return this._isApp;        }
  IsCordova()    {  return this._isCordova;    }
  IsNative()     {  return this._isNative;     }
  IsMobileWeb()  {  return this._isMobileWeb;  }
  IsDesktop()    {  return this._isDesktop;    }
  IsEmulator()   {  return this._isEmulator;   }
  IsCors()       {  return this._useCors;      }
  UseHttpProxy() {  return this._useHttpProxy; }
  UseEncodeUri() {  return this._useEncodeUri; }

  GetRuntimeName():string
  {
    return this._isBrowser ? 'BROWSER' : 'NATIVE';
  }

  GetEnvironmentDetails(useAbbreviations:boolean):string
  {
    this.DetermineExecutionEnv();

    console.log('runtime.GetEnvironmentDetails'
    + " Desktop:" + this._isDesktop
    + " MobileWeb:" + this._isMobileWeb
    + " Browser:" + this._isBrowser
    + " Native:" + this._isNative
    + " Emulator:" + this._isEmulator  // this is a guess at the moment
    + " App:" + this._isApp
    + " Cordova:" + this._isCordova
    + " Cors:" + this._useCors
    + " HttpProxy:" + this._useHttpProxy
    + " EncodeUri:" + this._useEncodeUri
    );

    let details:string;

    if (useAbbreviations === true)
    {
      details = (this._isDesktop? " Dsk" : "" )
              + (this._isMobileWeb? " Web" : "" )
              + (this._isBrowser? " Brws" : "" )
              + (this._isNative? " Natv" : "" )
              + (this._isEmulator? " Emlt" : "" )
              + (this._isCordova? " Crdv" : "" )
              + (this._isApp? " App" : "" )
              + (this._useCors? " CORS" : "" )
              + (this._useHttpProxy? " Prxy" : "" )
              + (this._useEncodeUri? " EncUri" : "" )
              ;
    }
    else
    {
      details = (this._isDesktop? " Desktop" : "" )
              + (this._isMobileWeb? " MobileWeb" : "" )
              + (this._isBrowser? " Browser" : "" )
              + (this._isNative? " Native" : "" )
              + (this._isEmulator? " Emulator" : "" )
              + (this._isCordova? " Cordova" : "" )
              + (this._isApp? " App" : "" )
              + (this._useCors? " Cors" : "" )
              + (this._useHttpProxy? " HttpProxy" : "" )
              + (this._useEncodeUri? " EncodeUri" : "" )
              ;
    }

    if (this.consoleLog) console.log('runtime.GetEnvironmentDetails: ' + details);
    return details; 
  }

  public GetApkAndroidVersionCode():number  // android:versionCode
  {
    try
    {
        // the "special" Android version used in AndroidManifest.xml "android:versionCode"
        // and is required when uploading the APK to the Google Play Store
        // (I am calculating it here as a matter of convenience for that upload) 
        let AmbitMobileAppVersion = this.globalProvider.AmbitConfig.AmbitMobileAppVersion;

        // e.g. "2.05.1701131"  // Major.Minor.Build
        //       J.RR.YYMMDDn        J     RR  YYMMDDn
        let VersionArray = AmbitMobileAppVersion.split('.');

        // for Android try this to generate APK version code:
        // (1) YYMMDDn + (Major*10000) + (Minor*100)
        // (2) YY ... M+Major  ... MD+Minor ... Dn    
        //     17 ... 0+2      ... 12+06    ... 40 =  1721840

        let Major:any = VersionArray[0];
        let Minor:any = VersionArray[1];
        let Build:any = VersionArray[2];

        let ApkAndroidVersionCode = (Major * 10000) + (Minor * 100) + (Build * 1);

        console.log("runtime.GetApkAndroidVersionCode: " + ApkAndroidVersionCode 
                   + " currently hard-coded as AmbitAndroidVersionCode:" 
                   + this.globalProvider.AmbitConfig.AmbitAndroidVersionCode);
        return ApkAndroidVersionCode;
    }
    catch (err)
    {
        return err.message;
    }
  }

  public GetDeviceDetails():string
  {
    this.DetermineDeviceInfo();

    console.log('runtime.GetDeviceDetails'
    + " RunContext:" + this._AmbitMobileAppRunContext
    + " Product:" + this._DeviceProductCode
    + " Type:" + this._DeviceTypeCode
    + " Platform:" + this._DevicePlatformCode
    + " Os:" + this._DeviceOsVersionCode
    + " Brand:" + this._DeviceBrandCode
    + " Carrier:" + this._DeviceCarrierCode
    );

    let details:string = ""
    //+ (this._AmbitMobileAppRunContext? " " + this._AmbitMobileAppRunContext : "" )
    //+ ( (this._DeviceTypeCode && this._DeviceTypeCode !== Constants.SPEC_UNKNOWN)? " " + this._DeviceTypeCode : "" )
    + ( (this._DevicePlatformCode && this._DevicePlatformCode !== Constants.SPEC_UNKNOWN)? " " + this._DevicePlatformCode : "" )
    + ( (this._DeviceBrandCode && this._DeviceBrandCode !== Constants.SPEC_UNKNOWN)? " " + this._DeviceBrandCode : "" )
    + ( (this._DeviceProductCode && this._DeviceProductCode !== Constants.SPEC_UNKNOWN)? " " + this._DeviceProductCode : "" )
    + ( (this._DeviceOsVersionCode && this._DeviceOsVersionCode !== Constants.SPEC_UNKNOWN)? " " + this._DeviceOsVersionCode : "" )
    + ( (this._DeviceCarrierCode && this._DeviceCarrierCode !== Constants.SPEC_UNKNOWN)? " " + this._DeviceCarrierCode : "" )
    ;

    if (this.consoleLog) console.log('runtime.GetEnvironmentDetails: ' + details);
    return details.toLowerCase(); 
  }

  // ------------------------------------------------------
  // Device Information
  // ------------------------------------------------------
  public DetermineDeviceInfo()
  {
    // Call to setup all the Device specs using UserAgent
    //ambitUa.DetermineDeviceSpecsFromUserAgent(ambitUa.DetermineUserAgent());

    try
    {
      if (this._isNative)
      {
        if (this.consoleLog) console.log("MobileDevice.SetDeviceInfo - NATIVE DEVICE");
        this._AmbitMobileAppRunContext = this.GetRuntimeName();  //__IonicRunContext__;// + "-" + $cordovaDevice.getCordova();
        this._NativeDeviceUuid    = this.device.uuid;  // $cordovaDevice.getUUID();
        this._DeviceTypeCode      = "MOBILE";
        this._DeviceProductCode   = this.device.model; // $cordovaDevice.getModel();
        this._DevicePlatformCode  = this.device.platform;
        this._DeviceOsVersionCode = this.device.platform + "-" + this.device.version;
        this._DeviceBrandCode     = this._DetermineNativeDeviceBrandCode(this.device.platform, this.device.model);
        this._DeviceCarrierCode   = Constants.SPEC_UNKNOWN; // "unknown";
      }
      else if (this._isBrowser) // if (__IonicRunContext__ == 'BROWSER')
      {
        if (this.consoleLog) console.log("MobileDevice.SetDeviceInfo - BROWSER");
        this._SetUserAgentSettings();

        this._AmbitMobileAppRunContext = this.GetRuntimeName(); // __IonicRunContext__;
        this._NativeDeviceUuid    = "";
        this._DeviceProductCode   = this._DetermineBrowserDeviceProductCode();
        this._DeviceTypeCode      = this._DetermineBrowserDeviceTypeCode();      // BROWSER | DESKTOP | MOBILE | TABLET
        this._DevicePlatformCode  = this._DetermineBrowserDevicePlatformCode();  // LINUX | MAC | WINDOWS
        this._DeviceOsVersionCode = this._DetermineBrowserDeviceOsVersionCode(); // win7 | mac | etc.
        this._DeviceBrandCode     = this._DetermineBrowserDeviceBrandCode();     // PC | APPLE | ANDROID | SAMSUNG | HTC
        this._DeviceCarrierCode   = Constants.SPEC_UNKNOWN; // "unknown";
      }
    }
    catch (error)
    {
      console.error("runtime.DetermineDeviceInfo: Exception", error);
    }

    if (this.consoleLog)
    {
      console.log('runtime.DetermineDeviceInfo'
      + " RunContext:" + this._AmbitMobileAppRunContext
      + " NativeDeviceUuid:" + this._NativeDeviceUuid
      + " Product:" + this._DeviceProductCode
      + " Type:" + this._DeviceTypeCode
      + " Platform:" + this._DevicePlatformCode
      + " OsVersion:" + this._DeviceOsVersionCode
      + " Brand:" + this._DeviceBrandCode
      + " Carrier:" + this._DeviceCarrierCode
      );
    } 
  }

  public GetObscuredDeviceGuidForDisplay():string
  {
    if (!this._NativeDeviceUuid)
    {
      return "";
    }

    if (this._NativeDeviceUuid.length > 5)
    {
      // first four characters ... four characters from the end
      return this._NativeDeviceUuid.substr(0,4) + "..." + this._NativeDeviceUuid.substr(-4); 
    }
    else
    {
      return this._NativeDeviceUuid;
    }
  }

  public GetDeviceOsVersion():string
  {
    return this._DevicePlatformCode + "-" + this._DeviceOsVersionCode;
  }

  // GETTERS FOR ALL THE CALCULATED VALUES FOR DEVICE
  GetDeviceTypeCode():string  {  return this._DeviceTypeCode;  }
  GetDeviceBrandCode():string  {  return this._DeviceBrandCode;  }
  GetDevicePlatformCode():string  {  return this._DevicePlatformCode;  }
  GetDeviceProductCode():string  {  return this._DeviceProductCode;  }
  GetDeviceOsVersionCode():string  {  return this._DeviceOsVersionCode;  }
  GetAmbitMobileAppRunContext():string  {  return this._AmbitMobileAppRunContext;  }
  GetNativeDeviceUuid():string  {  return this._NativeDeviceUuid;  }
  GetDeviceCarrierCode():string  {  return this._DeviceCarrierCode;  }

  // SUPPORTING FUNCTIONS FOR ALL THE CALCULATED VALUES FOR RUNTIME
  _DetermineNativeDeviceBrandCode(DevicePlatformCode:string, DeviceProductCode:string):string
  {
    if ((!DevicePlatformCode) && (!DeviceProductCode)) { return Constants.SPEC_UNKNOWN; }

    try
    {
      // probably best to do this analysis on the API end (ToDo)
      const DevicePlatformUpper = DeviceProductCode.toUpperCase();
      if (DevicePlatformUpper.includes("IOS"))   { return "APPLE";     }

      const DeviceProductUpper = DeviceProductCode.toUpperCase();
      if (DeviceProductUpper.includes("IPHONE")) { return "APPLE";     }
      if (DeviceProductUpper.includes("IPAD"))   { return "APPLE";     }
      if (DeviceProductUpper.includes("PIXEL"))  { return "GOOGLE";    }
      if (DeviceProductUpper.includes("GT-"))    { return "SAMSUNG";   }
      if (DeviceProductUpper.includes("SM-"))    { return "SAMSUNG";   }
      if (DeviceProductUpper.includes("SGH-"))   { return "SAMSUNG";   }
      if (DeviceProductUpper.includes("HUAWEI")) { return "HUAWEI";    }
      if (DeviceProductUpper.includes("LIFE"))   { return "BLU";       }
      if (DeviceProductUpper.includes("HTC"))    { return "HTC";       }
      if (DeviceProductUpper.includes("G26A"))   { return "TECH CORP"; }
      if (DeviceProductUpper.includes("MOTO"))   { return "MOTOROLA";  }
      if (DeviceProductUpper.includes("LG-"))    { return "LG";        }

      return Constants.SPEC_UNKNOWN; // "unknown";
    }
    catch (error)
    {
      return Constants.SPEC_UNKNOWN; // "unknown";
    }
  }

  _DetermineBrowserDeviceProductCode()
  {
    try
    {
      if ((!this._browserInfo) || (!this._browserInfo.browser)) { return "unknown"; }

      // probably best to do this analysis on the API end (ToDo)
      if (this._browserInfo.browser === "ed")  { return "EDGE";   }
      if (this._browserInfo.browser === "ie9") { return "IE9";    }
      if (this._browserInfo.browser === "ie10") { return "IE10";  }
      if (this._browserInfo.browser === "ie11") { return "IE11";  }
      if (this._browserInfo.browser === "ie?") { return "IE8";    }
      if (this._browserInfo.browser === "ff")  { return "FIREFOX";    }
      if (this._browserInfo.browser === "gc") { return "CHROME";    }
      if (this._browserInfo.browser === "sa") { return "SAFARI";    }
      if (this._browserInfo.browser === "op") { return "OPERA";    }
      return this._browserInfo.browser; 
    }
    catch (error)
    {
      return Constants.SPEC_UNKNOWN; // "unknown";
    }
  }

  // BROWSER | DESKTOP | MOBILE | TABLET
  _DetermineBrowserDeviceTypeCode()
  {
    try
    {
      //if ((!this._browserInfo) || (!this._browserInfo.mobile) || (!this._browserInfo.tablet) ) { return "BROWSER"; }
      if ((!this._browserInfo)) { return "BROWSER"; }

      if (this._browserInfo.tablet === true) { return "TABLET";  }
      if (this._browserInfo.mobile === 0)    { return "DESKTOP"; }
      else                                   { return "MOBILE";  }
    }
    catch (error)
    {
      return "BROWSER";
    }
  }

  // LINUX | MAC | WINDOWS
  _DetermineBrowserDevicePlatformCode()
  {
    try
    {
      if ((!this._browserInfo) || (!this._browserInfo.os)) { return "BROWSER"; }

      // probably best to do this analysis on the API end (ToDo)
      const OsUpper = this._browserInfo.os.toUpperCase();
      if (OsUpper.includes("LINUX")) { return "LINUX"; }
      if (OsUpper.includes("MAC"))   { return "MAC";   }
      if (OsUpper.includes("WIN"))   { return "PC";   }
      if (OsUpper.includes("NIX"))   { return "NIX";   }
      return "BROWSER";
    }
    catch (error)
    {
      return "BROWSER";
    }
  } 

  // // win7 | mac | etc.
  _DetermineBrowserDeviceOsVersionCode()
  {
    try
    {
      if ((!this._browserInfo) || (!this._browserInfo.os) || (!this._browserInfo.browser)) { return "unknown"; }

      const DeviceOsVersionCode = this._browserInfo.os + " " + this._browserInfo.browser;
      return DeviceOsVersionCode.toUpperCase();
    }
    catch (error)
    {
      return Constants.SPEC_UNKNOWN; // "unknown";
    }
  }

  // PC | APPLE | ANDROID | SAMSUNG | HTC
  _DetermineBrowserDeviceBrandCode()
  {
    try
    {
      if ((!this._browserInfo) || (!this._browserInfo.os)) { return "unknown"; }

      // probably best to do this analysis on the API end (ToDo)
      const OsUpper = this._browserInfo.os.toUpperCase();
      if (OsUpper.includes("LINUX")) { return "LINUX"; }
      if (OsUpper.includes("MAC"))   { return "APPLE";   }
      if (OsUpper.includes("WIN"))   { return "PC";   }
      return Constants.SPEC_UNKNOWN; // "unknown";
    }
    catch (error)
    {
      return Constants.SPEC_UNKNOWN; // "unknown";
    }
  }

  _SetUserAgentSettings()
  {
    // ref: https://jsfiddle.net/oriadam/ncb4n882/
    // ref: https://stackoverflow.com/questions/21757105/javascript-how-to-check-user-agent-for-mobile-tablet

    /* Legend
          browser:
            ed = Microsoft Edge
            ie9 = Explorer 9
            ie10 = Explorer 10
            ie11 = Explorer 11
            ie? = Explorer 8 and below
            ff = Firefox
            gc = Google Chrome
            sa = Safari
            op = Opera
          os:
            win7
            win8
            win9
            win10
            winvista
            winxp
            winnt
            mac
            linux
            nix
          mobile - including tablets:
            0 = Not a mobile or tablet device
            w = Windows Phone (Nokia Lumia)
            i = iOS (iPhone iPad)
            a = Android
            b = Blackberry
            s = Undetected mobile device running Safari
            1 = Undetected mobile device
          tablet:
            true
            false
          touch:
            true
            false
    */

  this._browserInfo.ua = Constants.SPEC_UNKNOWN; // "unknown";
  this._browserInfo.browser = Constants.SPEC_UNKNOWN; // "unknown";
  this._browserInfo.os = Constants.SPEC_UNKNOWN; // "unknown";
  this._browserInfo.touch = Constants.SPEC_UNKNOWN; // "unknown";
  this._browserInfo.mobile = Constants.SPEC_UNKNOWN; // "unknown"; 
  this._browserInfo.tablet = Constants.SPEC_UNKNOWN; // "unknown"; 

    try
    {
      const
        ua = navigator.userAgent,
// tslint:disable-next-line: max-line-length
        browser = /Edge\/\d+/.test(ua) ? 'ed' : /MSIE 9/.test(ua) ? 'ie9' : /MSIE 10/.test(ua) ? 'ie10' : /MSIE 11/.test(ua) ? 'ie11' : /MSIE\s\d/.test(ua) ? 'ie?' : /rv\:11/.test(ua) ? 'ie11' : /Firefox\W\d/.test(ua) ? 'ff' : /Chrom(e|ium)\W\d|CriOS\W\d/.test(ua) ? 'gc' : /\bSafari\W\d/.test(ua) ? 'sa' : /\bOpera\W\d/.test(ua) ? 'op' : /\bOPR\W\d/i.test(ua) ? 'op' : typeof MSPointerEvent !== 'undefined' ? 'ie?' : '',
// tslint:disable-next-line: max-line-length
        os = /Windows NT 10/.test(ua) ? "win10" : /Windows NT 6\.0/.test(ua) ? "winvista" : /Windows NT 6\.1/.test(ua) ? "win7" : /Windows NT 6\.\d/.test(ua) ? "win8" : /Windows NT 5\.1/.test(ua) ? "winxp" : /Windows NT [1-5]\./.test(ua) ? "winnt" : /Mac/.test(ua) ? "mac osx" : /Linux/.test(ua) ? "linux" : /X11/.test(ua) ? "nix" : "",
        touch = 'ontouchstart' in document.documentElement,
        mobile = /IEMobile|Windows Phone|Lumia/i.test(ua) ? 'w' : /iPhone|iP[oa]d/.test(ua) ? 'i' : /Android/.test(ua) ? 'a' : /BlackBerry|PlayBook|BB10/.test(ua) ? 'b' : /Mobile Safari/.test(ua) ? 's' : /webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua) ? 1 : 0,
        tablet = /Tablet|iPad/i.test(ua);

      this._browserInfo.ua = ua;
      this._browserInfo.browser = browser;
      this._browserInfo.os = os;
      this._browserInfo.mobile = mobile;
      this._browserInfo.tablet = tablet;
      this._browserInfo.touch = touch;

      if (this.consoleLog) console.log("runtime._SetUserAgentSettings - BROWSER", this._browserInfo);
    }
    catch(error)
    {
      console.error("runtime - _SetUserAgentSettings - ERROR", error);
    }
  }
}

